import { SECTION_ATTR } from '../services/MenuStore';
import styled, { media } from '../styled-components';
export const MiddlePanel = styled.div.withConfig({
  componentId: "sc-6itmo6-0"
})(["width:calc(100% - ", ");padding:0 ", "px;", ";"], props => props.theme.rightPanel.width, props => props.theme.spacing.sectionHorizontal, media.lessThan('medium', true)`
    width: 100%;
    padding: ${props => `${props.theme.spacing.sectionVertical}px ${props.theme.spacing.sectionHorizontal}px`};
  `);
export const Section = styled.div.attrs(props => ({
  [SECTION_ATTR]: props.id
})).withConfig({
  componentId: "sc-6itmo6-1"
})(["padding:", "px 0;&:last-child{min-height:calc(100vh + 1px);}& > &:last-child{min-height:initial;}", " ", ""], props => props.theme.spacing.sectionVertical, media.lessThan('medium', true)`
    padding: 0;
  `, (props: any) => props.underlined && `
    position: relative;

    &:not(:last-of-type):after {
      position: absolute;
      bottom: 0;
      width: 100%;
      display: block;
      content: '';
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    }
  ` || '');
export const RightPanel = styled.div.withConfig({
  componentId: "sc-6itmo6-2"
})(["width:", ";color:", ";background-color:", ";padding:0 ", "px;", ";"], props => props.theme.rightPanel.width, ({
  theme
}) => theme.rightPanel.textColor, props => props.theme.rightPanel.backgroundColor, props => props.theme.spacing.sectionHorizontal, media.lessThan('medium', true)`
    width: 100%;
    padding: ${props => `${props.theme.spacing.sectionVertical}px ${props.theme.spacing.sectionHorizontal}px`};
  `);
export const DarkRightPanel = styled(RightPanel).withConfig({
  componentId: "sc-6itmo6-3"
})(["background-color:", ";"], props => props.theme.rightPanel.backgroundColor);
export const Row = styled.div.withConfig({
  componentId: "sc-6itmo6-4"
})(["display:flex;width:100%;padding:0;", ";"], media.lessThan('medium', true)`
    flex-direction: column;
  `);